module.exports = __webpack_public_path__ + "static/img/bz3.fe33b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/bz3.png
// module id = 306
// module chunks = 0